import { useAuthStore } from '../lib/auth.js';

/**
 * Subscribe to auth fields individually so we never return a new object
 * identity from the selector. Returning `{...}` from a Zustand v5 selector
 * causes infinite re-renders under React StrictMode.
 */
export function useAuth() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  return {
    accessToken,
    user,
    isAuthenticated: accessToken !== null && user !== null,
  };
}
